import {useEffect,useState} from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Searchspan.css";

const SearchSpanTest = () => {

  const navigate = useNavigate();
   const [hasAccess, setHasAccess] = useState(null);
  
    useEffect(() => {
  
      const email = localStorage.getItem("user_email");
  
      if (!email) {
        navigate("/");
        return;
      }
  
      axios
        .get(`/check-access?email=${email}&test=working_memory`)
        .then(res => {
  
          console.log("API:", res.data); // 👈 debug
  
          if (res.data.allowed) {
            setHasAccess(true);
          } else {
            setHasAccess(false);
          }
  
        })
        .catch(() => navigate("/"));
  
    }, []);
  
    // 🔥 THIS PART IS VERY IMPORTANT
  
    if (hasAccess === null) {
      return <div>Loading...</div>;
    }
  
    if (hasAccess === false) {
      return (
        <div className="access-denied-container">
          <h2>🚫 Access Denied</h2>
          <p>You don’t have access to this test</p>
          <button onClick={() => navigate("/")}>Go Back</button>
        </div>
      );
    }
    
  

  return (
    <div className="rg-login-wrapper">

      {/* ================= HEADER SECTION ================= */}

      <div className="reaction-header-card">

        <h2 className="reaction-title">Search Span Test</h2>

        <p className="reaction-subtitle">
          Search span measures how quickly and accurately you can scan a visual
          field and locate the correct target among multiple distractions.
          It trains the brain to
          <strong> “Scan → Identify → Respond.”</strong>
        </p>

        <div className="reaction-pill">
          Test type: <strong>Visual scanning → Target detection</strong>
        </div>

        <hr className="reaction-divider" />

        {/* ================= WHY SECTION ================= */}

        <div className="reaction-why-card">

          <h3 className="why-title">
            Why search span matters in sport
          </h3>

          <p className="why-description">
            In sports, athletes constantly scan their environment to track
            teammates, opponents, and ball movement. A strong search span
            helps players process visual information faster and make better
            tactical decisions.
          </p>

          <div className="why-tags">
            <span>Faster visual scanning</span>
            <span>Better situational awareness</span>
            <span>Improved focus</span>
            <span>Better field awareness</span>
            <span>Quick target recognition</span>
          </div>

        </div>

      </div>

      {/* ================= HOW GAME WORKS ================= */}

      <div className="how-card">

        <h2 className="how-title">How the game works</h2>

          <ul className="how-list">

            <li>
              A grid of numbers from <strong>1 to 50</strong> will be displayed randomly.
            </li>

            <li>
              Your task is to <strong>find and click the numbers in order</strong> (1 → 2 → 3...).
            </li>

            <li>
              You will have <strong>60 seconds</strong> to find as many numbers as possible.
            </li>

            <li>
              Each correct number increases your score.
            </li>

            

            <li>
              Your final score is based on <strong>how many numbers you correctly find within time</strong>.
            </li>

          </ul>
        <p className="how-note">
          Best practice: use the same device and posture when comparing results.
        </p>

      </div>

      {/* ================= START TEST ================= */}

      <div className="start-test-section">

        <h2>Ready to test your visual scanning?</h2>

        <button
          className="start-test-btn"
          onClick={() => navigate("/search-span/play") }  // correct
        >
          Start Test
        </button>

      </div>

    </div>
  );
};

export default SearchSpanTest;